import React, { useEffect, useState, useCallback } from "react";
import { useNotify } from "react-admin";
import { useClub } from "../../club/ClubContext";
import { httpClient } from "../../httpClient";
import { Box, Typography, Card, CardContent, Button, TextField, CircularProgress } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";

export default function ShopSettingsPage() {
  const { clubId } = useClub();
  const notify = useNotify();
  const [paypalLink, setPaypalLink] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    if (!clubId) { setLoading(false); return; }
    setLoading(true);
    try {
      const { json } = await httpClient(`/api/shop/settings?club_id=${clubId}`);
      setPaypalLink(json?.paypal_link ?? "");
    } catch {
      notify("Fehler beim Laden", { type: "error" });
    } finally {
      setLoading(false);
    }
  }, [clubId, notify]);

  useEffect(() => { load(); }, [load]);

  const handleSave = async () => {
    setSaving(true);
    try {
      await httpClient(`/api/shop/settings?club_id=${clubId}`, {
        method: "PUT",
        body: JSON.stringify({ paypal_link: paypalLink.trim() || null }),
      });
      notify("Gespeichert");
    } catch {
      notify("Fehler beim Speichern", { type: "error" });
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <Box display="flex" justifyContent="center" mt={6}><CircularProgress /></Box>;

  return (
    <Box sx={{ maxWidth: 700, mx: "auto", p: { xs: 1, sm: 2, md: 3 } }}>
      <Typography variant="h5" fontWeight={700} display="flex" alignItems="center" gap={1} sx={{ mb: 2 }}>
        <SettingsIcon /> Shop-Einstellungen
      </Typography>

      <Card>
        <CardContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Typography fontWeight={700}>PayPal-Link</Typography>
          <Typography variant="body2" color="text.secondary">
            Dieser Link wird Mitgliedern angezeigt, die bei der Bestellung "PayPal" als Zahlungsart wählen.
            Bitte einen PayPal.Me-Basislink ohne Betrag eintragen (z.B. https://paypal.me/DeinVerein) —
            der jeweilige Bestellbetrag wird beim Anzeigen automatisch angehängt
            (paypal.me/DeinVerein/19.99/EUR). Einen Verwendungszweck kann PayPal.Me leider nicht
            vorausfüllen; das Mitglied wird stattdessen gebeten, die Bestellnummer manuell einzutragen.
          </Typography>
          <TextField
            label="PayPal-Link"
            fullWidth
            size="small"
            value={paypalLink}
            onChange={(e) => setPaypalLink(e.target.value)}
            placeholder="https://paypal.me/DeinVerein"
          />
          <Button
            variant="contained"
            onClick={handleSave}
            disabled={saving}
            sx={{ alignSelf: "flex-start" }}
          >
            {saving ? <CircularProgress size={18} color="inherit" /> : "Speichern"}
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
}
